//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscTrigger(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M11.3725 12.0909H13.9034V13.6383H8.03174L17.0183 3V10.5435H21.3325L12.3459 21.1818V15.1857H13.9034V16.9265L17.9917 12.0909H15.4608V7.25532L11.3725 12.0909Z" fill="currentColor" /><path d="M2 13.4174H7.33987V12.4174H2V13.4174Z" fill="currentColor" /><path d="M10.6773 16.07L2.66748 16.07L2.66748 15.07L10.6773 15.07V16.07Z" fill="currentColor" /><path d="M4.00244 10.7647L9.34231 10.7647V9.76468L4.00244 9.76468V10.7647Z" fill="currentColor" /></svg>;
}
export default IconMiscTrigger;